import { render } from "./adminManage.vue?vue&type=template&id=5caa0368"
import script from "./adminManage.vue?vue&type=script&lang=js"
export * from "./adminManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__